/**
 * Created by SH: 20/02/2020
 */

import { GameSetting } from "../../dev/setting/GameSetting";
import { RoadRageHEnginePlayer } from "./RoadRageEnginePlayer";
import { RoadRageSpriteSymbol } from "./symbol/RoadRageSpriteSymbol";
import { ReelEngineController } from "../../dev/reel/ReelEngineController";
import { SpinePlayer } from '../../dev/displayobject/SpinePlayer';

export class RoadRageEngineView extends ReelEngineController {

    protected attentionStop: boolean = false;
    
    protected attentionSpine:SpinePlayer;

    protected setupMode:boolean = false;
    protected laneSwitch:number[] = [];

    public get engine(): RoadRageHEnginePlayer { return this._engine as RoadRageHEnginePlayer; }

    public get AllSymbols(): RoadRageSpriteSymbol[] {
        return (this._animationContainer.children as RoadRageSpriteSymbol[]);
    }

    public get AllVisibleSymbols(): RoadRageSpriteSymbol[] {
        return (this._animationContainer.children as RoadRageSpriteSymbol[]).concat(this.AllStickySymbols).sort((a,b) => a.posID[0] - b.posID[0]);
    }
    
    public get AllStickySymbols(): RoadRageSpriteSymbol[] { return this._stickyContainer.children as RoadRageSpriteSymbol[]; }

    public get AllOrderSymbols(): RoadRageSpriteSymbol[] { 
        if(this.AllStickySymbols.length){
            const windowSyms = this.AllWindowSymbols;
            if(this.AllStickySymbols.length === windowSyms.length) return this.AllStickySymbols;

            const temp: RoadRageSpriteSymbol[] = [];
            windowSyms.forEach(s => {
                const stickyIndx:number = this.AllStickySymbols.findIndex(sticky => sticky.posID[0] === s.posID[0] )
                stickyIndx >= 0 ? temp.push(this.AllStickySymbols[stickyIndx]) : temp.push(s);
            })
            return temp;
        }
        return this.AllWindowSymbols;
    }

    public get topSymbol(): RoadRageSpriteSymbol { return this.AllSymbols[0]; }
    public get bottomSymbol(): RoadRageSpriteSymbol { return this.AllSymbols[this.AllSymbols.length - 1]; }

    public get windowTopSymbol(): RoadRageSpriteSymbol { return this.AllSymbols[this.overflowAmount] }
    public get windowBottSymbol(): RoadRageSpriteSymbol { return this.AllSymbols[this.AllSymbols.length - (1 + this.overflowAmount)]; }

    public get AllWindowSymbols(): RoadRageSpriteSymbol[] {
        return this.AllSymbols.filter(sym => { return (Math.max(...sym.posID) >= 0 && Math.min(...sym.posID) < (this.config.WINDOW_AMOUNT)) }).sort((a,b) => a.posID[0] - b.posID[0]);
    }

    public get visibleAmountOfSymbols():number{
        return this.AllWindowSymbols.length + this.AllStickySymbols.length;
    }

    public get symPreferedSize():number{
        return [144,126,108][this.config.WINDOW_AMOUNT-3];
    }

    public get stopDuration(): number {
        if (this.isQuickStop) return this.config.DURATION.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.config.DURATION.FAST_STOP;
        else if (this.attentionStop) return this.config.DURATION!.ATTENTION_STOP!;
        return this.config.DURATION.STOP;
    }

    public get stopDelay(): number {
        if (this.isQuickStop) return this.config.DELAY.QUICK_STOP;
        else if (GameSetting.isFastSpin) return this.config.DELAY.FAST_STOP;
        return this.config.DELAY.STOP;
    }

    createReelEngine(): void {
        this._engine = new RoadRageHEnginePlayer(this.engineCallbacks(), this._animationContainer);
        this._engine.stepDistance = this.currentStepDistance;
    }

    protected createNewSymbol(id: number, symbolName: string, state?: string): RoadRageSpriteSymbol {
        const sym:RoadRageSpriteSymbol = new RoadRageSpriteSymbol(id, symbolName, state, this.symPreferedSize);
        if(this.setupMode) sym.setupMode(this.laneSwitch[this.reelID], this.setupFromRight);
        return sym;
    }
}
